export default "__VITE_ASSET__CoFGpkZf__"